const SvgBracketsPlusIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <path
        d="M15.475 16.6663C16.5267 16.6663 17.38 15.8138 17.38 14.7613V10.9522L18.3325 9.99967L17.38 9.04717V5.23801C17.38 4.18551 16.5275 3.33301 15.475 3.33301M4.52352 3.33301C3.47102 3.33301 2.61852 4.18551 2.61852 5.23801V9.04717L1.66602 9.99967L2.61852 10.9522V14.7613C2.61852 15.8138 3.47102 16.6663 4.52352 16.6663M9.99935 6.66634V13.333M6.66602 9.99967H13.3327"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgBracketsPlusIcon
